import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
@Injectable()
export class LoaderService {
    private static _loaderEnabled = new BehaviorSubject<boolean>(false);

    get loaderEnabled() {
        return LoaderService._loaderEnabled;
    }

    public static showLoader() {
        LoaderService._loaderEnabled.next(true);
    }

    public static hideLoader() {
        LoaderService._loaderEnabled.next(false);
    }
}
